import { render, staticRenderFns } from "./VisitRegistryForm.vue?vue&type=template&id=556013b6&scoped=true"
import script from "./VisitRegistryForm.vue?vue&type=script&lang=js"
export * from "./VisitRegistryForm.vue?vue&type=script&lang=js"
import style0 from "./VisitRegistryForm.vue?vue&type=style&index=0&id=556013b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556013b6",
  null
  
)

export default component.exports